import { useMemo } from 'react'
import { getNestedOrFloatingElementById, useSlsStateContext } from '@fs/zion-sls'
import { useR2StateContext } from '../../../providers/r2Provider/R2Context'

const useEventPanelOnIndex = () => {
  const r2State = useR2StateContext()
  const zionSlsState = useSlsStateContext()

  const selectedPerson = useMemo(
    () => getNestedOrFloatingElementById(zionSlsState.images, r2State.selectedPersonId),
    [r2State.selectedPersonId, zionSlsState.images]
  )

  const event = useMemo(() => {
    const activeElementId = r2State.activeElementId
    if (!selectedPerson || activeElementId === 'addingEvent') return null

    const currentActiveElement = getNestedOrFloatingElementById([selectedPerson], activeElementId)
    return currentActiveElement?.elementType === 'EVENT' ? currentActiveElement : null
  }, [selectedPerson, r2State.activeElementId])

  return {
    selectedPerson,
    event,
  }
}

export default useEventPanelOnIndex
